import UserDetails from "./UserDetails";

export default function UserProfileContent() {
    return (
        <UserDetails />
    );
}